var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMotivationFlatline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_494_motivation_flatline",
    "data-name": "#494_motivation_flatline"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 300.53,
    cy: 57.97,
    r: 14.92,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.54,73.39a15.43,15.43,0,0,1-14.67-10.65,15.41,15.41,0,1,1,29.32-9.53h0a15.4,15.4,0,0,1-14.65,20.18Zm0-29.84a14.65,14.65,0,0,0-4.47.71,14.43,14.43,0,1,0,18.17,9.26h0a14.45,14.45,0,0,0-13.7-10Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.54,70.4a12.42,12.42,0,0,1-11.08-18.06,12.42,12.42,0,1,1,14.91,17.45A12.46,12.46,0,0,1,300.54,70.4Zm0-23.86a11.44,11.44,0,1,0,5.17,1.25A11.35,11.35,0,0,0,300.54,46.54Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,63.61l.51,1.55-1.24.4-.52-1.62c-2.55.53-4.73-.21-5.89-2.49l2.49-1.32A2.58,2.58,0,0,0,301,61.62L300.1,59c-2.24.16-4.73.23-5.44-2-.64-2,.64-3.84,3.24-4.79l-.45-1.4,1.23-.4.47,1.44c2.36-.46,4.37.28,5.4,2l-2.44,1.43a2.39,2.39,0,0,0-2.2-1.06l.73,2.24c2.3-.21,5.12-.35,5.94,2.18C307.24,60.64,305.89,62.6,303,63.61Zm-3.65-7-.67-2.06c-1,.37-1.46.95-1.25,1.57S298.31,56.64,299.31,56.58Zm4.55,3c-.22-.68-1.2-.74-2.43-.67l.79,2.44C303.54,60.87,304.07,60.2,303.86,59.56Z",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.69,
    cy: 65.54,
    r: 14.92,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.68,81a15.28,15.28,0,0,1-6-1.22,15.41,15.41,0,0,1,.19-28.48,15.41,15.41,0,1,1,5.8,29.7Zm0-29.84a14.42,14.42,0,1,0,13.26,20h0a14.43,14.43,0,0,0-13.26-20Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.68,78a12.45,12.45,0,1,1,4.68-.92A12.39,12.39,0,0,1,312.68,78Zm0-23.86A11.43,11.43,0,1,0,323.21,70h0a11.43,11.43,0,0,0-6.08-15A11.48,11.48,0,0,0,312.69,54.11Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.84,71.39l-.64,1.5-1.19-.5.66-1.57c-2.28-1.27-3.43-3.25-2.82-5.74l2.75.63a2.59,2.59,0,0,0,1,2.87L311.7,66c-1.79-1.34-3.72-2.92-2.82-5,.8-1.91,3-2.48,5.58-1.5l.57-1.35,1.2.51L315.64,60c2.09,1.2,3.12,3.08,2.79,5l-2.78-.51a2.38,2.38,0,0,0-1-2.24l-.92,2.17c1.88,1.34,4.11,3.08,3.07,5.53C316,72,313.71,72.55,310.84,71.39Zm1.84-7.7.84-2c-1-.36-1.72-.24-2,.37S311.88,63.08,312.68,63.69Zm1.48,5.23c.28-.67-.41-1.34-1.39-2.1l-1,2.37C313.07,69.7,313.9,69.54,314.16,68.92Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.51,
    cy: 65.52,
    r: 14.92,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.52,80.93a15.41,15.41,0,1,1,14.65-20.18h0a15.41,15.41,0,0,1-14.65,20.18Zm0-29.84a14.65,14.65,0,0,0-4.47.71,14.34,14.34,0,1,0,4.47-.71Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.51,77.94a12.43,12.43,0,1,1,3.84-.61A12.45,12.45,0,0,1,294.51,77.94Zm0-23.85A11.43,11.43,0,1,0,305.37,62h0a11.45,11.45,0,0,0-10.85-7.89Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.94,71.15l.5,1.55-1.23.4-.52-1.61c-2.56.52-4.73-.22-5.89-2.5l2.49-1.32a2.57,2.57,0,0,0,2.64,1.49l-.86-2.64c-2.23.16-4.72.23-5.43-2-.64-2,.64-3.84,3.24-4.79l-.46-1.39,1.24-.41.46,1.45c2.37-.47,4.38.27,5.4,2l-2.43,1.43a2.39,2.39,0,0,0-2.21-1.06l.73,2.24c2.3-.21,5.13-.35,5.95,2.18C301.21,68.18,299.87,70.14,296.94,71.15Zm-3.65-7-.67-2.06c-1,.37-1.46.95-1.26,1.57S292.29,64.18,293.29,64.12Zm4.55,3c-.23-.68-1.2-.74-2.44-.67l.8,2.45C297.52,68.41,298.05,67.74,297.84,67.1Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.71,206l-3,10,28.59-.47c-1.54-6.67-14.68-9.52-14.68-9.52Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.76,216.46a.51.51,0,0,1-.4-.2.53.53,0,0,1-.08-.44l2.95-10a.49.49,0,0,1,.48-.36h11.06c.55.12,13.48,3,15.07,9.89a.49.49,0,0,1-.1.42.51.51,0,0,1-.38.2l-28.59.47Zm3.32-10-2.65,9,27.26-.45c-2-5.67-13.22-8.34-14.08-8.53Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.87,121.86c.3,0,6.14-1.94,6.14-1.94s3.32-6.14,4.23-5.13a2.84,2.84,0,0,1,.8,2s2.31-2.61,3.22-1.41,3,7.55,1.11,8.75-14.79,6.36-14.79,6.36Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.58,131a.52.52,0,0,1-.5-.46l-.7-8.64a.47.47,0,0,1,.11-.36.46.46,0,0,1,.32-.17c.37-.08,3.7-1.16,5.86-1.86.92-1.69,3-5.18,4.21-5.32a.8.8,0,0,1,.73.27,3.69,3.69,0,0,1,.77,1.3,3.86,3.86,0,0,1,2.3-1.18,1.23,1.23,0,0,1,1,.51c.78,1,2.35,5.46,1.9,7.9a2.27,2.27,0,0,1-.93,1.58c-1.93,1.21-14.34,6.18-14.86,6.39A.43.43,0,0,1,194.58,131Zm-.17-8.76.61,7.54c2.61-1.05,12.47-5,14.08-6.06a1.34,1.34,0,0,0,.48-.91c.39-2.11-1.06-6.23-1.72-7.12a.24.24,0,0,0-.22-.11c-.54,0-1.64.89-2.22,1.55a.51.51,0,0,1-.58.13.5.5,0,0,1-.3-.51,2.29,2.29,0,0,0-.61-1.55c-.58.27-2.13,2.47-3.48,5a.49.49,0,0,1-.28.23C198,121.1,195.47,121.93,194.41,122.24Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.38,236.13s-5.28,12.07-5,14.18,12.83,6.26,12.83,6.26l14.37.38a15,15,0,0,0-3.75-4.46c-3.28-2.5-6.26-4.47-6.56-5.35a64.5,64.5,0,0,1-1.05-6.79Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.6,257.45h0l-14.37-.38-.15,0c-3-1-12.85-4.42-13.17-6.67s4.47-13.2,5-14.45a.5.5,0,0,1,.64-.26l10.86,4.21a.54.54,0,0,1,.32.41,63.47,63.47,0,0,0,1,6.7c.17.5,2.08,1.91,3.94,3.28.76.56,1.59,1.17,2.44,1.82a15,15,0,0,1,3.94,4.75.51.51,0,0,1-.1.43A.53.53,0,0,1,110.6,257.45Zm-14.28-1.38,13.43.35a16.61,16.61,0,0,0-3.2-3.53c-.85-.65-1.67-1.25-2.44-1.82-2.72-2-4-3-4.29-3.77a55.24,55.24,0,0,1-1-6.59l-10.14-3.94c-2,4.66-5,12.08-4.75,13.47C84.05,251.35,90.45,254.13,96.32,256.07Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.87,97.21s16.29,29.85,18.7,29.25,19.72-6.33,19.72-6.33l3.06,10.37s-21.14,17.4-26.8,13.78c-8.91-5.7-14.68-21.64-14.68-21.64Z",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.79,
    y: 171.48,
    width: 46.13,
    height: 29.91,
    rx: 3.91,
    transform: "translate(67.08 -14.32) rotate(19.66)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.18,207.69a4.29,4.29,0,0,1-1.49-.26h0L51.62,194.55a4.45,4.45,0,0,1-2.51-2.27,4.38,4.38,0,0,1-.16-3.37l7.43-20.81A4.41,4.41,0,0,1,62,165.43l36.08,12.89a4.42,4.42,0,0,1,2.67,5.64l-7.43,20.81a4.41,4.41,0,0,1-4.15,2.92ZM88,206.49a3.41,3.41,0,0,0,4.36-2.06l7.43-20.81a3.42,3.42,0,0,0-2.06-4.36L61.68,166.38a3.41,3.41,0,0,0-4.36,2.06l-7.43,20.81A3.41,3.41,0,0,0,52,193.6Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.35,186.59a.47.47,0,0,1-.17,0L59.83,174.29a.5.5,0,0,1-.31-.64.5.5,0,0,1,.64-.3l34.35,12.27a.51.51,0,0,1,.31.64A.52.52,0,0,1,94.35,186.59Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.91,175.72a.51.51,0,0,1-.17,0l-16-5.74a.46.46,0,0,1-.28-.25.48.48,0,0,1,0-.39l1.1-3.07a3.44,3.44,0,0,1,4.41-2.09l10.49,3.75a3.44,3.44,0,0,1,2.09,4.41l-1.1,3.07a.51.51,0,0,1-.47.34ZM72.5,169.18l15.11,5.4.93-2.6a2.47,2.47,0,0,0-1.49-3.14l-10.48-3.75a2.47,2.47,0,0,0-3.14,1.49Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.88,156.7s-1.11,3-1.66,5.17a29.17,29.17,0,0,0-.41,6.23c-.59-.58-1.46-.66-2.07-1.16a7.88,7.88,0,0,1-.39,2.65,2.68,2.68,0,0,1-1.89,1.75,3.38,3.38,0,0,1-1.41-.1c-1.68-.37-4.47-1.1-5-3a4.09,4.09,0,0,1,.23-2.26c1-3,5.83-11.08,6.63-12.38",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.05,171.88a5,5,0,0,1-1.11-.15c-1.42-.32-4.74-1.06-5.38-3.39a4.5,4.5,0,0,1,.24-2.54c1.08-3.35,6.62-12.41,6.68-12.5a.5.5,0,0,1,.85.53c-1.43,2.32-5.71,9.56-6.58,12.27a3.63,3.63,0,0,0-.22,2c.42,1.55,2.7,2.24,4.63,2.67a2.91,2.91,0,0,0,1.21.1,2.24,2.24,0,0,0,1.52-1.44,7.9,7.9,0,0,0,.35-2.49.5.5,0,0,1,.3-.44.51.51,0,0,1,.52.07,3.19,3.19,0,0,0,.84.45l.38.16a31.82,31.82,0,0,1,.45-5.41c.55-2.2,1.64-5.1,1.68-5.22a.49.49,0,0,1,.64-.29.5.5,0,0,1,.3.64s-1.11,3-1.65,5.11a29.82,29.82,0,0,0-.39,6.09.48.48,0,0,1-.12.36.51.51,0,0,1-.67.07h0l-.06,0a2.81,2.81,0,0,0-.95-.54l-.3-.13a6.89,6.89,0,0,1-.39,2,3.21,3.21,0,0,1-2.26,2.06A2.21,2.21,0,0,1,84.05,171.88Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.1,115.78c-.85.47-31.63,37.26-35.8,44.65l-10-4.93s10.26-22.66,33.95-51.75C125.49,97.17,127.1,115.78,127.1,115.78Z",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.51,144.28s32,13.21,32.8,19.81S177.61,206,177.61,206H160.86s6.71-28.36,4.93-29.74-27.7-8.14-27.7-8.14l-37.16,74.48L85.4,238.41l27-89.94Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.93,243.07l-.13,0-15.53-4.16a.52.52,0,0,1-.35-.63l27-89.94a.51.51,0,0,1,.43-.35l43.07-4.18a.5.5,0,0,1,.24,0c1.32.54,32.31,13.4,33.1,20.21.77,6.63-10.25,40.65-10.72,42.09a.47.47,0,0,1-.47.34H160.86a.48.48,0,0,1-.39-.18.51.51,0,0,1-.09-.43c3.17-13.4,5.94-28,5.08-29.26-1.2-.93-16.72-5.2-27.11-7.91l-37,74.11A.49.49,0,0,1,100.93,243.07Zm-14.91-5L100.67,242l37-74.12a.5.5,0,0,1,.57-.26c2.67.7,26.08,6.82,27.89,8.22s-2.51,20.71-4.61,29.64h15.76c1.18-3.66,11.26-35.25,10.56-41.33-.59-5.15-23.46-15.67-32.38-19.35l-42.61,4.14Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.51,144.28,119.15,151l9-53.71s5.49-3.94,9.94-3.92c5.31,0,9.84,4.1,11.62,5.12C153,100.41,155.51,144.28,155.51,144.28Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.15,151.54a.51.51,0,0,1-.36-.15.5.5,0,0,1-.14-.44l9-53.7a.49.49,0,0,1,.2-.32c.23-.17,5.64-4,10.19-4h0c4.41,0,8.25,2.71,10.55,4.31.52.37,1,.69,1.31.88,3.33,1.92,5.6,38.78,6,46.15a.5.5,0,0,1-.41.52l-36.36,6.76Zm9.49-53.92-8.88,52.8L155,143.87c-1-16.89-3.3-43.64-5.49-44.9-.37-.22-.84-.55-1.39-.93-2.19-1.53-5.87-4.11-10-4.13h0C134.27,93.91,129.58,97,128.64,97.62Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.34,93.62c-.54.35,1,8.17,1.13,8.87.82,6.6,1.94,13.3,2.53,19.88.57,6.33-1.91,13.08-3.12,19.29a96.1,96.1,0,0,1-6.5,20.68c-1.09,2.45-2.4,5-4.67,6.39a12.7,12.7,0,0,1-5.76,1.55,49.88,49.88,0,0,1-10.22-.19A9.48,9.48,0,0,1,104,169c-2.32-1.41-3.16-4.49-2.72-7.17.7-4.19,3.44-8.2,4.68-12.34a92.76,92.76,0,0,0,2.76-13.31c1.33-9.16,1.77-18.41,3-27.58C117.44,97.21,124.36,97.79,134.34,93.62Z",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.87,97.21c.22.05,3.73,13.4,3.8,14.31.88,10.32-3.38,19.36,1.88,29.16,2,3.71,4.55,7.1,6.55,10.81a2.16,2.16,0,0,1,.36,1.4,2.21,2.21,0,0,1-1.19,1.27c-4.13,2.49-9.06,4.88-13.58,3.19a11.15,11.15,0,0,1-6.08-6.44A29.51,29.51,0,0,1,146.9,142c-1.07-13.54.21-26.92-1.11-40.39,0-.35-1-8.18-1.16-8.2A73.41,73.41,0,0,0,156.87,97.21Z",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.37,99.25l-2.76,2.69,2.24,1.54s-2.36,17.54-10.65,20-11.5,1.64-11.5,1.64l-4.57,5.92s7.1,2,7.61,2.2,15.56-3.34,17.93-12.67a96.88,96.88,0,0,0,2.77-16.77l1.5-1.88Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.63,120.76a.49.49,0,0,1-.4-.21l-7-9.52a.5.5,0,0,1,0-.65l4.2-4.33-5.24-1.36a.51.51,0,0,1-.35-.35.5.5,0,0,1,.12-.48L130.41,97a.5.5,0,0,1,.73.69l-5.84,6.25,5.25,1.37a.53.53,0,0,1,.36.35.5.5,0,0,1-.13.48l-4.49,4.65L133,120a.51.51,0,0,1-.11.7A.47.47,0,0,1,132.63,120.76Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.29,154.06a.5.5,0,0,1-.46-.3.52.52,0,0,1,.27-.66c4.16-1.71,11.71-5.06,11.79-5.09a.5.5,0,0,1,.66.26.49.49,0,0,1-.26.65c-.07,0-7.64,3.39-11.81,5.11A.58.58,0,0,1,113.29,154.06Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,117.72a.51.51,0,0,1-.2,0,.51.51,0,0,1-.25-.67l4.31-9.57-5.44-2.84a.52.52,0,0,1-.25-.31.47.47,0,0,1,.06-.4l3.33-5.31-4.42-.88a.49.49,0,0,1-.39-.58.51.51,0,0,1,.59-.4l5.13,1a.52.52,0,0,1,.36.3.5.5,0,0,1,0,.46L150.36,104l5.38,2.81a.51.51,0,0,1,.22.65l-4.5,10A.49.49,0,0,1,151,117.72Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.82,89.45a15.5,15.5,0,0,1-14.47-2.68A9.76,9.76,0,0,0,124.8,83a4.84,4.84,0,0,1-5.35,0,10.24,10.24,0,0,1-3.6-4.31c3.73-.52,6.71-3.37,9-6.39s4.14-6.4,7-8.81A15.54,15.54,0,0,1,149,62c1.23.7,3.38,2,3.86,3.45.41,1.25-.4,2.07-.36,3.3.06,1.62.85,2.43.44,4.19a14.92,14.92,0,0,1-2.38,4.81,39.63,39.63,0,0,1-4,4.57A25.51,25.51,0,0,1,135.82,89.45Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.06,90.69a16.49,16.49,0,0,1-10-3.52.5.5,0,0,1-.2-.42.46.46,0,0,1,.23-.4,9.24,9.24,0,0,0,2.41-2.21,5.79,5.79,0,0,1-4.3-.73,10.56,10.56,0,0,1-3.79-4.52.48.48,0,0,1,0-.45.49.49,0,0,1,.37-.27c3-.41,5.83-2.44,8.64-6.19.61-.81,1.19-1.65,1.77-2.49a30.54,30.54,0,0,1,5.35-6.4,16.13,16.13,0,0,1,17.73-1.57c1.5.86,3.57,2.18,4.08,3.73a3.42,3.42,0,0,1-.11,2.22,3.65,3.65,0,0,0-.22,1.22,6,6,0,0,0,.28,1.54,5.11,5.11,0,0,1,.15,2.78A15.55,15.55,0,0,1,151,78a28.63,28.63,0,0,1-3.14,3.66l-.93,1a25.85,25.85,0,0,1-11,7.31h0A16.45,16.45,0,0,1,131.06,90.69Zm-8.84-3.91A14.85,14.85,0,0,0,135.67,89h0a24.91,24.91,0,0,0,10.53-7l.94-1a28,28,0,0,0,3-3.53,14.47,14.47,0,0,0,2.31-4.65,4.13,4.13,0,0,0-.15-2.29,7.43,7.43,0,0,1-.31-1.76,4.78,4.78,0,0,1,.26-1.55,2.42,2.42,0,0,0,.12-1.61c-.3-.91-1.52-2-3.63-3.18a15.08,15.08,0,0,0-16.59,1.47,30,30,0,0,0-5.17,6.2c-.59.85-1.18,1.7-1.79,2.52-2.77,3.69-5.59,5.82-8.61,6.46a8.94,8.94,0,0,0,3.1,3.52,4.35,4.35,0,0,0,4.79,0,.5.5,0,0,1,.75.63A10.24,10.24,0,0,1,122.22,86.78Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.17,78.59s2.82,5.31,2,6.27-3,.07-3,.07",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,85.81a5.71,5.71,0,0,1-2-.42.5.5,0,0,1,.38-.92c.61.24,2,.59,2.41.08.26-.46-.72-3.13-2.09-5.72a.5.5,0,0,1,.2-.68.5.5,0,0,1,.68.21c1.11,2.09,2.85,5.75,2,6.82A1.93,1.93,0,0,1,153,85.81Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.2,67.51c1.93,1.92.87,9.9.63,12.25-.34,3.31-.76,6.62-1.26,9.91-.31,2.09-5.75,1.61-6.65.89l.05,8.38s-2.67.46-6.87-2S134,93.46,134,93.46l1.28-9.54s3.59.37,6.12-3.71,3.08-10.66,3.08-10.66S150.31,65.64,152.2,67.51Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.38,99.47a13.18,13.18,0,0,1-6.53-2.09c-4-2.35-4.4-3.55-4.38-3.95l1.28-9.58a.51.51,0,0,1,.55-.43c.13,0,3.32.27,5.65-3.47,2.44-3.93,3-10.38,3-10.44a.57.57,0,0,1,.22-.38c.64-.42,6.26-4.07,8.38-2,1.72,1.71,1.4,7,.85,12l-.07.63c-.35,3.32-.77,6.66-1.26,9.93a2,2,0,0,1-1.43,1.54,9.46,9.46,0,0,1-5.22,0l.05,7.61a.49.49,0,0,1-.41.5A4,4,0,0,1,144.38,99.47Zm-9.9-6c.07.18.61,1.17,3.88,3.08a12.36,12.36,0,0,0,6.11,2l-.05-7.91a.5.5,0,0,1,.28-.45.51.51,0,0,1,.53.06,8,8,0,0,0,5.05.18c.48-.19.75-.44.8-.76.49-3.26.91-6.58,1.25-9.88l.07-.64c.29-2.62,1.06-9.6-.56-11.2-1.12-1.12-4.75.57-6.91,2-.13,1.25-.81,6.9-3.13,10.64a7.57,7.57,0,0,1-6.11,3.94Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.73,87.19a3.91,3.91,0,0,1-4.19-2.9",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.39,87.71a4.44,4.44,0,0,1-4.32-3.26.51.51,0,0,1,.31-.64.5.5,0,0,1,.63.31,3.41,3.41,0,0,0,3.65,2.57.5.5,0,0,1,.56.43.49.49,0,0,1-.41.56A2.83,2.83,0,0,1,151.39,87.71Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.61,80.11a4.43,4.43,0,0,0-.71-2.37,6.72,6.72,0,0,0-1.05-1.62,2.2,2.2,0,0,0-1.74-.71,2,2,0,0,0-1.4.9,3.93,3.93,0,0,0-.57,1.61,7.12,7.12,0,0,0,2.68,6.61l-.17-.21",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.82,85a.48.48,0,0,1-.3-.11,7.68,7.68,0,0,1-2.87-7.09A4.3,4.3,0,0,1,140.3,76a2.52,2.52,0,0,1,1.76-1.12,2.65,2.65,0,0,1,2.14.86,7.18,7.18,0,0,1,1.15,1.74,5,5,0,0,1,.76,2.64.5.5,0,0,1-1-.09,4,4,0,0,0-.65-2.09,6.07,6.07,0,0,0-1-1.49,1.66,1.66,0,0,0-1.32-.57,1.49,1.49,0,0,0-1,.69,3.24,3.24,0,0,0-.49,1.39,6.65,6.65,0,0,0,2.11,5.84.49.49,0,0,1,.3.19l.17.21a.5.5,0,0,1-.05.66A.47.47,0,0,1,142.82,85Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.92,90.56a8.88,8.88,0,0,1-3.86-3.2s-.3,5.06,3.88,6.93Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.94,94.79a.45.45,0,0,1-.2,0c-4.45-2-4.2-7.2-4.18-7.42a.5.5,0,0,1,.93-.22,8.47,8.47,0,0,0,3.62,3,.5.5,0,0,1,.31.46l0,3.73a.48.48,0,0,1-.23.42A.5.5,0,0,1,144.94,94.79ZM141.67,89a6.36,6.36,0,0,0,2.77,4.49l0-2.58A10.72,10.72,0,0,1,141.67,89Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 150.5,
    cy: 76.12,
    rx: 1.19,
    ry: 0.47,
    transform: "translate(37.85 201.63) rotate(-74.92)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.59,
    y1: 75.28,
    x2: 149.38,
    y2: 73.99,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.59,75.78a.55.55,0,0,1-.25-.07l-2.21-1.29a.5.5,0,1,1,.5-.86l2.21,1.28a.51.51,0,0,1,.18.69A.5.5,0,0,1,151.59,75.78Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104.2,
    y1: 141.27,
    x2: 120.68,
    y2: 122.64,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.2,141.77a.46.46,0,0,1-.33-.13.49.49,0,0,1-.05-.7l16.49-18.63a.49.49,0,0,1,.7,0,.51.51,0,0,1,0,.71L104.57,141.6A.51.51,0,0,1,104.2,141.77Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.05,110.48C258,102,260.2,76.07,260.23,75.81l.21-2.22h15.27v4.9H265.05c.1,5.83,2.05,21.39,19.58,27.34Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.05,111a.41.41,0,0,1-.16,0C257.45,102.3,259.7,76,259.73,75.76l.21-2.22a.5.5,0,0,1,.5-.45h15.27a.5.5,0,0,1,.5.5v4.9a.5.5,0,0,1-.5.5H265.56c.21,6.43,2.62,20.73,19.23,26.37a.51.51,0,0,1,.29.25.58.58,0,0,1,0,.39l-1.58,4.64A.49.49,0,0,1,283.05,111ZM260.89,74.09l-.17,1.77c0,.25-2.12,25.45,22,34l1.25-3.7C266.77,100,264.65,84.81,264.55,78.5a.54.54,0,0,1,.14-.36.53.53,0,0,1,.36-.15h10.16v-3.9Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,110.48l-1.58-4.65c17.52-6,19.48-21.5,19.58-27.34H325.35v-4.9h15.27l.21,2.22C340.86,76.07,343,102,318,110.48Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,111a.54.54,0,0,1-.22,0,.51.51,0,0,1-.25-.29L316,106a.5.5,0,0,1,.31-.63c16.6-5.64,19-19.94,19.23-26.37H325.35a.5.5,0,0,1-.5-.5v-4.9a.5.5,0,0,1,.5-.5h15.27a.51.51,0,0,1,.5.45l.21,2.22c0,.27,2.19,26.58-23.16,35.19A.45.45,0,0,1,318,111Zm-.95-4.84,1.26,3.7c24.09-8.52,22-33.73,22-34l-.16-1.76H325.85V78H336a.55.55,0,0,1,.36.15.54.54,0,0,1,.14.36C336.4,84.81,334.29,100,317.06,106.14Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.46,69l-51.85-.46s-.46,22.25,5.21,36.36c4.72,11.74,10.43,16.36,15.28,18.24a13.8,13.8,0,0,1,1,5.77,29,29,0,0,1-2.76,9.78h14.38s-3-4.94-2.88-9.66a26.75,26.75,0,0,1,.89-5.87c5.49-2.64,12.33-9.35,16-19C326.61,91.08,326.46,69,326.46,69Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.72,139.17H293.34a.52.52,0,0,1-.43-.23.5.5,0,0,1,0-.49,28.49,28.49,0,0,0,2.71-9.58,13,13,0,0,0-.89-5.36c-6.28-2.53-11.45-8.73-15.35-18.44-5.65-14-5.26-36.33-5.25-36.56a.49.49,0,0,1,.5-.49h0l51.86.46a.51.51,0,0,1,.49.5c0,.22.1,22.34-4.79,35.31-3.84,10.22-11,16.69-16,19.2a25.11,25.11,0,0,0-.82,5.53c-.11,4.52,2.78,9.35,2.81,9.4a.49.49,0,0,1-.43.75Zm-13.6-1h12.75c-.84-1.59-2.62-5.41-2.53-9.17a26.68,26.68,0,0,1,.91-6,.47.47,0,0,1,.26-.32c4.88-2.35,11.93-8.67,15.73-18.75,4.41-11.73,4.7-31.13,4.72-34.46L275.1,69c0,3.35.08,23,5.19,35.67,3.83,9.54,8.88,15.59,15,18a.51.51,0,0,1,.28.28,14,14,0,0,1,1,6A27.94,27.94,0,0,1,294.12,138.17Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.18,138.21h34.7a2.38,2.38,0,0,1,2.38,2.38v8.65a0,0,0,0,1,0,0H280.8a0,0,0,0,1,0,0v-8.65A2.38,2.38,0,0,1,283.18,138.21Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.26,149.75H280.8a.5.5,0,0,1-.5-.5v-8.66a2.89,2.89,0,0,1,2.88-2.88h34.7a2.89,2.89,0,0,1,2.88,2.88v8.66A.5.5,0,0,1,320.26,149.75Zm-39-1h38.46v-8.16a1.88,1.88,0,0,0-1.88-1.88h-34.7a1.88,1.88,0,0,0-1.88,1.88Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.93,
    y: 148.63,
    width: 51.2,
    height: 5.35,
    rx: 1.93,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.2,154.48H276.86a2.43,2.43,0,0,1-2.43-2.44v-1.48a2.43,2.43,0,0,1,2.43-2.43H324.2a2.43,2.43,0,0,1,2.43,2.43V152A2.43,2.43,0,0,1,324.2,154.48Zm-47.34-5.35a1.43,1.43,0,0,0-1.43,1.43V152a1.44,1.44,0,0,0,1.43,1.44H324.2a1.44,1.44,0,0,0,1.43-1.44v-1.48a1.43,1.43,0,0,0-1.43-1.43Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.23,257.45H49.13a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h65.6V239a.5.5,0,0,1,.5-.5h44.1V215.77a.5.5,0,0,1,.5-.5h49.81V180.11a.5.5,0,0,1,.5-.5h41.57V154a.5.5,0,0,1,.5-.5h98.66a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5H252.71v25.63a.5.5,0,0,1-.5.5H210.64v35.16a.5.5,0,0,1-.5.5H160.33V239a.51.51,0,0,1-.5.5h-44.1V257A.5.5,0,0,1,115.23,257.45Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.8,131h-.11a.51.51,0,0,1-.38-.6c0-.16,3.6-15.82,1.24-25.69a.5.5,0,1,1,1-.23c2.41,10.1-1.08,25.49-1.23,26.14A.51.51,0,0,1,158.8,131Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.82,124.64a.5.5,0,0,1-.22-.94,2.53,2.53,0,0,0,1.12-2,3,3,0,0,1,0-1.69.5.5,0,0,1,.52-.34.52.52,0,0,1,.45.44,8.07,8.07,0,0,1,0,1.45l.07.11a1.47,1.47,0,0,0,1.24.47.49.49,0,0,0,.49-.2c.51-.76-.25-3.32-1-4.88a.5.5,0,0,1,.92-.41c.32.71,1.86,4.35.88,5.84a1.51,1.51,0,0,1-1.35.65,2.93,2.93,0,0,1-1.51-.39,3,3,0,0,1-1.47,1.89A.48.48,0,0,1,201.82,124.64Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.53 76.91 305.44 86.87 316.43 88.46 308.48 96.21 310.36 107.16 300.53 101.99 290.7 107.16 292.58 96.21 284.63 88.46 295.62 86.87 300.53 76.91",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.95,
    y: 147.68,
    width: 22.84,
    height: 5.56,
    rx: 0.93,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.86,153.74h-21a1.43,1.43,0,0,1-1.43-1.43V148.6a1.43,1.43,0,0,1,1.43-1.42h21a1.43,1.43,0,0,1,1.43,1.42v3.71A1.43,1.43,0,0,1,337.86,153.74Zm-21-5.56a.42.42,0,0,0-.43.42v3.71a.43.43,0,0,0,.43.43h21a.43.43,0,0,0,.43-.43V148.6a.42.42,0,0,0-.43-.42Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.23,152.73a.5.5,0,0,1-.5-.5V148.7a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.53A.5.5,0,0,1,318.23,152.73Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.84,152.73a.5.5,0,0,1-.5-.5V148.7a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.53A.5.5,0,0,1,320.84,152.73Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.45,152.73a.5.5,0,0,1-.5-.5V148.7a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.53A.5.5,0,0,1,323.45,152.73Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.06,152.73a.5.5,0,0,1-.5-.5V148.7a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.53A.5.5,0,0,1,326.06,152.73Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.67,152.73a.5.5,0,0,1-.5-.5V148.7a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.53A.5.5,0,0,1,328.67,152.73Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.29,152.73a.5.5,0,0,1-.5-.5V148.7a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.53A.5.5,0,0,1,331.29,152.73Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.9,152.73a.5.5,0,0,1-.5-.5V148.7a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.53A.5.5,0,0,1,333.9,152.73Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.51,152.73a.5.5,0,0,1-.5-.5V148.7a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.53A.5.5,0,0,1,336.51,152.73Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.71,
    y: 142.11,
    width: 22.84,
    height: 5.56,
    rx: 0.93,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.62,148.18h-21a1.44,1.44,0,0,1-1.43-1.43V143a1.43,1.43,0,0,1,1.43-1.43h21a1.43,1.43,0,0,1,1.43,1.43v3.71A1.44,1.44,0,0,1,333.62,148.18Zm-21-5.57a.43.43,0,0,0-.43.43v3.71a.43.43,0,0,0,.43.43h21a.43.43,0,0,0,.43-.43V143a.43.43,0,0,0-.43-.43Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,147.17a.5.5,0,0,1-.5-.5v-3.54a.5.5,0,0,1,1,0v3.54A.5.5,0,0,1,314,147.17Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.6,147.17a.5.5,0,0,1-.5-.5v-3.54a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.54A.5.5,0,0,1,316.6,147.17Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.21,147.17a.5.5,0,0,1-.5-.5v-3.54a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.54A.5.5,0,0,1,319.21,147.17Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.82,147.17a.5.5,0,0,1-.5-.5v-3.54a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.54A.5.5,0,0,1,321.82,147.17Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.43,147.17a.5.5,0,0,1-.5-.5v-3.54a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.54A.5.5,0,0,1,324.43,147.17Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,147.17a.5.5,0,0,1-.5-.5v-3.54a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.54A.5.5,0,0,1,327,147.17Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.65,147.17a.5.5,0,0,1-.5-.5v-3.54a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.54A.5.5,0,0,1,329.65,147.17Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.26,147.17a.5.5,0,0,1-.5-.5v-3.54a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.54A.5.5,0,0,1,332.26,147.17Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.69,
    y: 136.55,
    width: 22.84,
    height: 5.56,
    rx: 0.93,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.6,142.61h-21a1.43,1.43,0,0,1-1.42-1.42v-3.71a1.43,1.43,0,0,1,1.42-1.43h21a1.43,1.43,0,0,1,1.43,1.43v3.71A1.43,1.43,0,0,1,334.6,142.61Zm-21-5.56a.43.43,0,0,0-.42.43v3.71a.42.42,0,0,0,.42.42h21a.43.43,0,0,0,.43-.42v-3.71a.44.44,0,0,0-.43-.43Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,141.61a.5.5,0,0,1-.5-.5v-3.54a.5.5,0,0,1,1,0v3.54A.5.5,0,0,1,315,141.61Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.58,141.61a.5.5,0,0,1-.5-.5v-3.54a.5.5,0,0,1,1,0v3.54A.5.5,0,0,1,317.58,141.61Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.19,141.61a.51.51,0,0,1-.5-.5v-3.54a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.54A.5.5,0,0,1,320.19,141.61Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.8,141.61a.51.51,0,0,1-.5-.5v-3.54a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.54A.5.5,0,0,1,322.8,141.61Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.41,141.61a.51.51,0,0,1-.5-.5v-3.54a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.54A.5.5,0,0,1,325.41,141.61Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,141.61a.51.51,0,0,1-.5-.5v-3.54a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.54A.5.5,0,0,1,328,141.61Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.63,141.61a.51.51,0,0,1-.5-.5v-3.54a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.54A.5.5,0,0,1,330.63,141.61Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.24,141.61a.51.51,0,0,1-.5-.5v-3.54a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.54A.5.5,0,0,1,333.24,141.61Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.42,
    y: 130.99,
    width: 22.84,
    height: 5.56,
    rx: 0.93,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.34,137.05h-21a1.43,1.43,0,0,1-1.43-1.43v-3.7a1.43,1.43,0,0,1,1.43-1.43h21a1.43,1.43,0,0,1,1.42,1.43v3.7A1.43,1.43,0,0,1,331.34,137.05Zm-21-5.56a.43.43,0,0,0-.43.43v3.7a.43.43,0,0,0,.43.43h21a.42.42,0,0,0,.42-.43v-3.7a.42.42,0,0,0-.42-.43Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.71,136.05a.5.5,0,0,1-.5-.5V132a.5.5,0,0,1,.5-.5.51.51,0,0,1,.5.5v3.54A.51.51,0,0,1,311.71,136.05Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.32,136.05a.5.5,0,0,1-.5-.5V132a.5.5,0,0,1,.5-.5.51.51,0,0,1,.5.5v3.54A.51.51,0,0,1,314.32,136.05Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.93,136.05a.5.5,0,0,1-.5-.5V132a.5.5,0,0,1,.5-.5.51.51,0,0,1,.5.5v3.54A.51.51,0,0,1,316.93,136.05Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.54,136.05a.5.5,0,0,1-.5-.5V132a.5.5,0,0,1,.5-.5.51.51,0,0,1,.5.5v3.54A.51.51,0,0,1,319.54,136.05Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.15,136.05a.5.5,0,0,1-.5-.5V132a.5.5,0,0,1,.5-.5.51.51,0,0,1,.5.5v3.54A.51.51,0,0,1,322.15,136.05Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.76,136.05a.5.5,0,0,1-.5-.5V132a.5.5,0,0,1,1,0v3.54A.5.5,0,0,1,324.76,136.05Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.37,136.05a.5.5,0,0,1-.5-.5V132a.5.5,0,0,1,1,0v3.54A.5.5,0,0,1,327.37,136.05Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330,136.05a.5.5,0,0,1-.5-.5V132a.5.5,0,0,1,1,0v3.54A.5.5,0,0,1,330,136.05Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.69,
    y: 125.43,
    width: 22.84,
    height: 5.56,
    rx: 0.93,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.6,131.49h-21a1.43,1.43,0,0,1-1.42-1.43v-3.7a1.43,1.43,0,0,1,1.42-1.43h21a1.43,1.43,0,0,1,1.43,1.43v3.7A1.43,1.43,0,0,1,334.6,131.49Zm-21-5.56a.42.42,0,0,0-.42.43v3.7a.42.42,0,0,0,.42.43h21a.43.43,0,0,0,.43-.43v-3.7a.43.43,0,0,0-.43-.43Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,130.49a.5.5,0,0,1-.5-.5v-3.54a.5.5,0,1,1,1,0V130A.5.5,0,0,1,315,130.49Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.58,130.49a.5.5,0,0,1-.5-.5v-3.54a.5.5,0,1,1,1,0V130A.5.5,0,0,1,317.58,130.49Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.19,130.49a.51.51,0,0,1-.5-.5v-3.54a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5V130A.5.5,0,0,1,320.19,130.49Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.8,130.49a.51.51,0,0,1-.5-.5v-3.54a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5V130A.5.5,0,0,1,322.8,130.49Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.41,130.49a.51.51,0,0,1-.5-.5v-3.54a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5V130A.5.5,0,0,1,325.41,130.49Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,130.49a.51.51,0,0,1-.5-.5v-3.54a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5V130A.5.5,0,0,1,328,130.49Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.63,130.49a.51.51,0,0,1-.5-.5v-3.54a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5V130A.5.5,0,0,1,330.63,130.49Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.24,130.49a.51.51,0,0,1-.5-.5v-3.54a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5V130A.5.5,0,0,1,333.24,130.49Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.56,
    y: 147.68,
    width: 22.84,
    height: 5.56,
    rx: 0.93,
    transform: "translate(543.97 300.91) rotate(-180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.48,153.74h-21a1.43,1.43,0,0,1-1.43-1.43V148.6a1.43,1.43,0,0,1,1.43-1.42h21a1.43,1.43,0,0,1,1.43,1.42v3.71A1.44,1.44,0,0,1,282.48,153.74Zm-21-5.56a.43.43,0,0,0-.43.42v3.71a.44.44,0,0,0,.43.43h21a.44.44,0,0,0,.43-.43V148.6a.43.43,0,0,0-.43-.42Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.12,152.73a.5.5,0,0,1-.5-.5V148.7a.5.5,0,0,1,1,0v3.53A.5.5,0,0,1,281.12,152.73Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.51,152.73a.5.5,0,0,1-.5-.5V148.7a.5.5,0,0,1,1,0v3.53A.5.5,0,0,1,278.51,152.73Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.9,152.73a.5.5,0,0,1-.5-.5V148.7a.5.5,0,0,1,1,0v3.53A.5.5,0,0,1,275.9,152.73Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.29,152.73a.5.5,0,0,1-.5-.5V148.7a.5.5,0,0,1,1,0v3.53A.5.5,0,0,1,273.29,152.73Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.68,152.73a.5.5,0,0,1-.5-.5V148.7a.5.5,0,0,1,1,0v3.53A.5.5,0,0,1,270.68,152.73Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.07,152.73a.5.5,0,0,1-.5-.5V148.7a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.53A.5.5,0,0,1,268.07,152.73Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.46,152.73a.5.5,0,0,1-.5-.5V148.7a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.53A.5.5,0,0,1,265.46,152.73Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.85,152.73a.5.5,0,0,1-.5-.5V148.7a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.53A.5.5,0,0,1,262.85,152.73Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.81,
    y: 142.11,
    width: 22.84,
    height: 5.56,
    rx: 0.93,
    transform: "translate(552.45 289.79) rotate(-180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.72,148.18h-21a1.43,1.43,0,0,1-1.42-1.43V143a1.43,1.43,0,0,1,1.42-1.43h21a1.43,1.43,0,0,1,1.43,1.43v3.71A1.44,1.44,0,0,1,286.72,148.18Zm-21-5.57a.43.43,0,0,0-.42.43v3.71a.43.43,0,0,0,.42.43h21a.43.43,0,0,0,.43-.43V143a.43.43,0,0,0-.43-.43Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.36,147.17a.5.5,0,0,1-.5-.5v-3.54a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.54A.5.5,0,0,1,285.36,147.17Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.75,147.17a.5.5,0,0,1-.5-.5v-3.54a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.54A.5.5,0,0,1,282.75,147.17Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.14,147.17a.5.5,0,0,1-.5-.5v-3.54a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.54A.5.5,0,0,1,280.14,147.17Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.53,147.17a.5.5,0,0,1-.5-.5v-3.54a.5.5,0,0,1,1,0v3.54A.5.5,0,0,1,277.53,147.17Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.92,147.17a.5.5,0,0,1-.5-.5v-3.54a.5.5,0,0,1,1,0v3.54A.5.5,0,0,1,274.92,147.17Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.31,147.17a.5.5,0,0,1-.5-.5v-3.54a.5.5,0,0,1,1,0v3.54A.5.5,0,0,1,272.31,147.17Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.7,147.17a.5.5,0,0,1-.5-.5v-3.54a.5.5,0,0,1,1,0v3.54A.5.5,0,0,1,269.7,147.17Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.09,147.17a.5.5,0,0,1-.5-.5v-3.54a.5.5,0,0,1,1,0v3.54A.5.5,0,0,1,267.09,147.17Z",
    fill: "#d1d3d4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotivationFlatline);
export default __webpack_public_path__ + "static/media/Motivation_Flatline.897526226ed34cd0f901589278a03056.svg";
export { ForwardRef as ReactComponent };